import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'
import { supabaseApi } from '~/supabase/api'
import { FilterOperator, InventoryV2, ModelV2, Supplier, Visitor } from '~/supabase/types'

export const GET_INVENTORY_QUERY_KEY = 'get-inventory'

export type FetchedInventory = Omit<InventoryV2, 'sales'> & {
  sales: Visitor | null
  models_v2: Omit<ModelV2, 'supplier'> & {
    suppliers: Supplier | null
  }
}

export type GetVisitorFilters = Array<
  | {
      value: string | number | string[] | null
      column: keyof InventoryV2
      operator: FilterOperator
    }
  | { operator: 'range'; column: number; value: number }
>

export const useGetInventory = (params?: {
  filters?: GetVisitorFilters
  keepPreviousData?: boolean
  enabled?: boolean
}) => {
  const { filters, enabled } = params ?? {}

  return useQuery({
    queryKey: [GET_INVENTORY_QUERY_KEY, filters],
    queryFn: async () => {
      const visitorsTable = supabaseApi
        .from('inventory_v2')
        .select('* ,models_v2 (*, suppliers (*)), sales(*)')
        .limit(10000)

      const promise = filters
        ? filters.reduce((acc, { value, column, operator }) => {
            if (operator === 'range') {
              return acc.range(column, value)
            }
            // @ts-expect-error type casting required here as (column:string,value:any)=> typeof visitorsTable
            return acc[operator](column, value)
          }, visitorsTable)
        : visitorsTable

      const { data, error } = await promise.order('id', { ascending: false })

      if (error) {
        toast.error(error.message)
        throw error
      }
      return data
    },
    placeholderData: params?.keepPreviousData ? keepPreviousData : undefined,
    refetchInterval: 10 * 60 * 1000,
    enabled,
  })
}
